import { MENU_ACTIVE_ITEM, MENU_TOGGLE, MENU_HIDE } from './action-types'

const Reducer = (state = [], action) => {
    switch (action.type) {
        case MENU_ACTIVE_ITEM:
            return activeItem(state, action.payload)
        case MENU_TOGGLE:
            return toggleMenu(state)
        case MENU_HIDE:
            return menuHide(state)
        default:
            return state
    }
}

const activeItem = (state, payload) => {
    state.activeItem = payload.key
    state.showMenu = false
    return state
}

const toggleMenu = (state) => {
    state.showMenu = !state.showMenu
    return state
}

const menuHide = (state) => {
    state.showMenu = false
    return state
}

export default Reducer